<!-- 업무보드 편집기 탭 -->
<template>
  <!-- SNAPSHOT의 경우 type1 class 추가 -->
  <section id="boardTab" class="board-tab1" :class="boardSection[0] == 'SNAPSHOT' ? 'type1' : ''" :style="dBHeight"
    @mousedown="boardMouseDown"
    @dragover="boardDragDropFile($event, 'over')"
    @dragleave="boardDragDropFile($event, 'leave')"
    @drop="boardDragDropFile($event, 'drop')"
    >
    <!-- [상단부 선택메뉴 & 상태줄 영역] -->
    <h2 class="hide" v-if="boardSection[0] != 'SNAPSHOT'">{{$i18nUtil.trans("entity.paper.groupKbn.pro","과제 보드")}}</h2>
    <div class="board_edit_top" v-if="boardSection[0] != 'SNAPSHOT'">
      <!-- 진행상태 영역(정보공유 제외) -->
      <div class="dropdown ty1" v-if="boardSection[0] != 'SHAR'">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on">
              <span 
                :class="'ico-' +
                  (paperStatus === 'GOOD' ? 'evaluate-good' 
                  : paperStatus === 'SO' ? 'evaluate-so' 
                  : paperStatus === 'DELAY' ? 'evaluate-delay' : 'evaluate-exceeded')"
                >
              </span>
              {{ paperStatus === 'GOOD' ? $i18nUtil.trans("entity.paper.paperStatus.GOOD","정상")
                : paperStatus === 'SO' ? $i18nUtil.trans("entity.paper.paperStatus.SO","이슈 발생")
                : paperStatus === 'DELAY' ? $i18nUtil.trans("entity.paper.paperStatus.DELAY","보고 필요")
                : $i18nUtil.trans("entity.paper.paperStatus.EXCEEDED","종료") }}
            </v-btn>
          </template>
          <div class="dropdown-list">
            <div class="dropdown-list-item">
              <div class="tit">
                <button type="button" 
                  :class="paperStatus == 'GOOD' ? 'active' : ''"
                  @click="changePaperStatus('GOOD')"
                >
                  <span class="ico-evaluate-good"></span> {{ $i18nUtil.trans("entity.paper.paperStatus.GOOD","정상") }}
                </button>
              </div>
            </div>
            <div class="dropdown-list-item">
              <div class="tit">
                <button type="button" 
                  :class="paperStatus == 'SO' ? 'active' : ''"
                  @click="changePaperStatus('SO')"
                >
                  <span class="ico-evaluate-so"></span> {{ $i18nUtil.trans("entity.paper.paperStatus.SO","이슈 발생") }}
                </button>
              </div>
            </div>
            <div class="dropdown-list-item">
              <div class="tit">
                <button type="button" 
                  :class="paperStatus == 'DELAY' ? 'active' : ''"
                  @click="changePaperStatus('DELAY')"
                >
                  <span class="ico-evaluate-delay"></span> {{ $i18nUtil.trans("entity.paper.paperStatus.DELAY","보고 필요") }}
                </button>
              </div>
            </div>
            <div class="dropdown-list-item">
              <div class="tit">
                <button type="button" 
                  :class="paperStatus == 'EXCEEDED' ? 'active' : ''"
                  @click="changePaperStatus('EXCEEDED')"
                >
                  <span class="ico-evaluate-exceeded"></span> {{ $i18nUtil.trans("entity.paper.paperStatus.EXCEEDED","종료") }}
                </button>
              </div>
            </div>
          </div>
        </v-menu>
      </div>
      <div class="droplayer icon info tip relative" v-if="boardSection[0] != 'SHAR'">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on">{{$i18nUtil.trans("message.BoardEditor.001","설명")}}</v-btn>
          </template>
          <div class="dropdown-list ">
            <div class="tooltip-b tl" style="width: 413px;">
              <div v-if="tenantId !== '203'">{{ $i18nUtil.trans("message.ProjectFilter.001","평가정보는 과제/보드 멤버가 수동으로 변경 가능합니다.") }}</div>
              <div v-if="tenantId === '203'">{{ $i18nUtil.trans("message.ProjectFilter.001_1","진행단계는 과제/보드 멤버가 수동으로 변경 가능합니다.") }}</div>
              <div v-if="tenantId !== '203'" v-html="$i18nUtil.trans('message.ProjectFilter.010','평가 기준')"></div>
              <div v-if="tenantId === '203'" v-html="'&lt; '+$i18nUtil.trans('entity.projectList.status','진행단계')+' &gt'"></div>
              <div class="tit"><span class="ico-evaluate-good"></span> {{$i18nUtil.trans("entity.paper.paperStatus.GOOD","정상")}}</div>
              <ul class="list-dot white">
                <li>{{ $i18nUtil.trans("message.ProjectFilter.002","이슈가 없는 상황, 정상적으로 진행 중") }}</li>
              </ul>
              <div class="tit"><span class="ico-evaluate-so"></span> {{$i18nUtil.trans("entity.paper.paperStatus.SO","이슈 발생")}}</div>
              <ul class="list-dot white">
                <li>{{$i18nUtil.trans("message.ProjectFilter.003","이슈/승인/지원 상황 발생에 따른 협의/의사결정 필요")}}</li>
                <li>{{$i18nUtil.trans("message.ProjectFilter.004","상위 관리자 주도 下, 이슈 논의 및 의사결정으로 해결")}}</li>
              </ul>
              <div class="tit"><span class="ico-evaluate-delay"></span> {{$i18nUtil.trans("entity.paper.paperStatus.DELAY","보고 필요")}}</div>
                <ul class="list-dot white">
                  <li>{{$i18nUtil.trans("message.ProjectFilter.005","상위 관리자 선에서 해결 불가능한 사안, 논의 후 보고 안건 선정")}}</li>
                  <li>{{$i18nUtil.trans("message.ProjectFilter.006","보고 대상자 의사결정 또는 방향성 논의로 해결")}}</li>
                </ul>
                <div class="tit"><span class="ico-evaluate-exceeded"></span> {{$i18nUtil.trans("entity.paper.paperStatus.EXCEEDED","종료")}}</div>
                <ul class="list-dot white">
                  <li>{{$i18nUtil.trans("message.ProjectFilter.007","목표 달성(Task 완료)피벗/재편성, 사업 중단")}}</li>
                  <li>{{$i18nUtil.trans("message.ProjectFilter.008","상위 관리자/보고 대상자와 논의 후 종료")}}</li>
                </ul>
              </div>
            </div>
          </v-menu>
      </div>
      <div class="dividing_line_ty1" v-if="boardSection[0] != 'SHAR'"></div>
      <div :class="boardSection[0] != null && boardSection[0] != 'PRIV' ? '' : 'new-ty1'">
        <button 
          type="button" 
          class="btn_link ell-singleline permit_everyone" 
          @click="goProjectPage(projectInfo)" 
          v-if="paperInfo.categoryMid != null && boardSection[0] != 'SHAR' && boardSection[0] != 'CFRC'">
          {{
            projectInfo == null ? 
              (paperInfo.categoryInfo.section == null ? $i18nUtil.trans('entity.cogroup.groupKbn.user','프라이빗') 
                : (paperInfo.categoryInfo.section == 'SHAR' ? $i18nUtil.trans('entity.cogroup.groupKbn.shar','정보공유') : $i18nUtil.trans('entity.cogroup.groupKbn.cfrc.002','회의/협의체') )) 
            : projectInfo.projectName
          }}
        </button>
        
        <button type="button" class="btn_link ell-singleline permit_everyone" @click="goProjectPage(projectInfo)" v-if="(boardSection[0] == 'SHAR' || boardSection[0] == 'CFRC')">{{category.selectedCategory.categoryName}}</button>
        <div class="dropdown ty1" v-if="paperInfo.categoryMid != null && !( (boardSection[0] == 'SHAR') || boardSection[0] == 'CFRC')">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" class="ell-singleline">{{ category.selectedCategory.categoryName }}</v-btn>
            </template>
            <div class="dropdown-list">
              <div class="scroll">
                <div class="dropdown-list-item"
                  v-for="(categoryItem, categoryIndex) in category.categoryList"
                  :value="categoryItem.categoryMid"
                  :key="categoryIndex"
                  >
                  <div class="tit">
                    <button type="button"
                      @click="changeCategory(categoryItem)"
                      :class="category.selectedCategory.categoryMid == categoryItem.categoryMid ? 'active' : ''"
                    >
                      {{ categoryItem.categoryName }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </v-menu>
        </div>
        <div class="last_update">
          {{$i18nUtil.trans("entity.paper.filter.lastUpdate","마지막 업데이트")}}
          {{ $moment(lastUpdInfo.lastUpdDate).format("YYYY.MM.DD") }}
          {{ $i18nUtil.getLanguage() !== 'ko' && lastUpdInfo.lastUpdUserNameEn != null ? lastUpdInfo.lastUpdUserNameEn : lastUpdInfo.lastUpdUserName }}
        </div>
      </div>
      
      <!-- TODO 임시 - 잠금설정 -->
      <!-- <button type="button" @click="changePaperLockYn(paperLockYn)">
        {{ String(paperLockYn) === "1" ? "잠금해제" : "잠금처리" }}
      </button>
      <div class="dividing_line_ty1"></div> -->
      <!-- TODO 임시 - 상위관리자 참조 -->
      <!-- <button type="button" @click="changePaperSuperiorYn(superiorMgrYn)">
        {{ String(superiorMgrYn) === "1" ? "상위관리자 참조" : "일반" }}
      </button> -->
      <!-- <button
        type="button"
        class="ico-switch_vip"
        :class="{ active: (String(superiorMgrYn) == '1' ? true : false) }"
        @click="changePaperSuperiorYn(superiorMgrYn)"
      >
        VIP
      </button> -->
    </div>
    <!-- /[상단부 선택메뉴 & 상태줄 영역] -->

    <!-- [상단부 제목줄 영역] -->
    <div class="edit_tit" v-if="boardSection[0] != 'SNAPSHOT'">
      <div class="new_board_tit_box">
        <button type="button" class="btn_lock" :class="titleLockYn && paperTitleModifyUseYn ? 'active':''" @click="checkAuthBtn" v-if="paperTitleModifyUseYn"></button>
        <input type="text" class="h1"
        :readonly="paperInfo.permission < 2 || !titleLockYn"
        v-model="paperInfo.paperTitle"
        @blur="saveBoard"
        @keyup="onTitleInputKey"
        @input="paperInfo.paperTitle = $event.target.value"
        :placeholder="$i18nUtil.trans('message.RegistBoardModal.001','보드의 제목을 입력해주세요.')" />
      </div>
      <div class="character-limit_box txtr"><div class="error txtr hidden" ref="titleInputError"></div><span class="count">&nbsp;</span></div>
      <div>
        <button
        type="button" 
        class="btn-opinion-open permit_everyone"
        @click="paperAllComment(true)">
        </button>
      </div>
      <!-- [태그설정] -->
      <div class="tag_setting" v-if="boardHashTagUse">
        <div class="tag_btn">
          <button type="button" class="btn_link_add" @click="setTags">{{$i18nUtil.trans("message.RegistBoardModal.003","태그설정")}}</button>
        </div>
        <div class="tag_wrap">
          <div class="tag_inner">
            <div v-for="(tag, idx) in selectedTags" :key="'selectedTag_'+idx">#{{tag.htag}}</div>
          </div>
        </div>
      </div>
      <!-- /[태그설정] -->
      <!-- <div class="calendar_box_grp" v-if="paperInfo.permission == 2 && boardSection[0] != 'SHAR'"> -->
      <div class="calendar_box_grp" v-if="boardSection[0] != 'SHAR'">
        <div class="calendar_box">
          <datepicker 
            :format="dateFormat"
            :placeholder="paperInfo.permission == 2 ? $i18nUtil.trans('message.placeholder.select.startDate','시작일 선택') : $i18nUtil.trans('message.placeholder.startDate','시작일')"
            @closed="changePaperPeriod('startDay')"
            :disabled="paperInfo.permission != 2"
            v-model="getStartDay">
          </datepicker>
        </div>
        <span>~</span>
        <div class="calendar_box">
          <datepicker 
            :format="dateFormat"
            :placeholder="paperInfo.permission == 2 ? $i18nUtil.trans('message.placeholder.select.endDate','종료일 선택') : $i18nUtil.trans('message.placeholder.endDate','종료일')"
            @closed="changePaperPeriod('endDay')"
            :disabled="paperInfo.permission != 2"
            v-model="getEndDay">
          </datepicker>
        </div>
        <button type="button" class="btn-refresh" @click="dateReset">
          {{$i18nUtil.trans("button.refresh","새로고침")}}
        </button>
        <button type="button" class="btn-show-sche" @click="showCalendar">{{$i18nUtil.trans("title.Dashboard.tab.001.Calendar","일정")}}</button>
      </div>
      <!-- 표 버블 메뉴 END -->
    </div>
    <!-- /[상단부 제목줄 영역] -->
    <!-- [업무보드 블럭 영역] -->
    <draggable
      id="content-editor"
      v-bind="dragOptions"
      handle=".block_handle"
      @change="handleDrop"
      @end="handleDrop">
      <component
        ref="contentBlocks"
        v-for="(paperBlockId) in paperBlockIdList"
        :class="paperBlockId == notiBoardBlockId?'comment_highlight':''"
        :is="paperBlockMap[paperBlockId].component"
        :key="paperBlockId"
        :bdata="paperBlockMap[paperBlockId].bdata"
        :paperInfo="paperInfo"
        :blockInfo="blockInfo"
        :boardSection="boardSection"
        :boardMemberInfo="boardMemberInfo"
        :transmitter="transmitter"
        :userInfo="userInfo"
        :paperBlockIdList="paperBlockIdList"
        :paperBlockMap="paperBlockMap"
        :boardUtil="boardUtil"
        :context="blockContext"
        :todoSelectedblockId="todoSelectedblockId"
        :memberSelector="memberSelector"
        @viewComment="viewComment"
        @refreshBoardMemberInfo="refreshBoardMemberInfo"
        @requestURLContent="requestURLContent"
        @blockMatch="blockMatch"
        @focusTable="focusTable"
        :paperBlockId="paperBlockId"
        :focusedTableBlockId="focusedTableBlockId"
        :tableCommands="tableCommands"
        :focusTableActive="focusTableActive"
        :isRoute="isRoute"
        >
      </component>
    </draggable>
    <!-- /[업무보드 블럭 영역] -->

    <!-- [하단툴바 영역] -->
    <div class="edit_widget" :class="{'active': showTableBubbleMenu}">
      <ul class="edit_tool">
        <li>
          <button type="button" class="img"
            data-btn-id="btn-add-image"
            @mousedown="clickToolbarButton">
            {{$i18nUtil.trans("message.BoardEditor.002","이미지삽입")}}
          </button>
        </li>
        <li>
          <dl class="dl_layer select_ty2" v-if="false || paperInfo.inOutKbn === 'OUT'">
            <dt ref="fileMenu"></dt>
            <dd>
              <ul>
                <li>
                  <button type="button" data-btn-id="btn-add-file"
                    @mousedown="$dm($refs.fileMenu).clt('active'); clickToolbarButton($event);" >
                    {{$i18nUtil.trans("message.BoardEditor.003","내컴퓨터")}}
                  </button>
                </li>
                <li>
                  <GoogleDrive
                    :config="gapiKeys"
                    @picked="googleFileUpload"
                    @click="googleFileUpload">
                    {{$i18nUtil.trans("message.BoardEditor.004","구글드라이브")}}
                  </GoogleDrive>
                </li>
              </ul>
            </dd>
          </dl>
          <button type="button" class="file"
            data-btn-id="btn-add-file"
            @click="
              if (false || paperInfo.inOutKbn === 'OUT') { cancelBlur(() => { $dm($refs.fileMenu).clt('active'); }); }
              else { clickToolbarButton($event); } ">
            {{$i18nUtil.trans("message.BoardEditor.005","파일추가")}}
          </button>
        </li>
        <li>
          <button type="button" class="table"
            data-btn-id="btn-add-table"
            @mousedown="clickToolbarButton">
            {{$i18nUtil.trans("message.BoardEditor.006","표추가")}}
          </button>
        </li>
        <li>
          <button type="button" class="link"
            data-btn-id="btn-add-link"
            @mousedown="clickToolbarButton">
            {{$i18nUtil.trans("message.BoardEditor.007","링크추가")}}
          </button>
        </li>
        <li v-if="boardSection[0] != 'SHAR' && tenantId != '201'">
          <button type="button" class="todo"
            data-btn-id="btn-add-todo"
            @mousedown="clickToolbarButton">
            {{$i18nUtil.trans("button.todo.add.editor","할 일추가")}}
          </button>
        </li>
        <li v-if="boardSection[0] != 'SHAR'">
          <button type="button" class="opinion"
            data-btn-id="btn-add-opinion"
            @mousedown="clickToolbarButton">
            {{$i18nUtil.trans("message.BoardEditor.014","의사결정")}}
          </button>
        </li>
        <li :class="state.focusedBlockType == BTPS().CONTENT ? '' : 'unabled'">
          <button type="button" class="bullet"
            data-btn-id="btn-add-bullet"
            @mousedown="clickToolbarButton">
            {{$i18nUtil.trans("message.BoardEditor.008","글머리기호")}}
          </button>
        </li>
        <li :class="state.focusedBlockType == BTPS().CONTENT ? '' : 'unabled'">
          <button type="button" class="number"
            data-btn-id="btn-add-number"
            @mousedown="clickToolbarButton">
            {{$i18nUtil.trans("message.BoardEditor.009","번호매기기")}}
          </button>
        </li>
        <li>
          <button type="button" class="division"
            data-btn-id="btn-add-division"
            @mousedown="clickToolbarButton">
            {{$i18nUtil.trans("message.BoardEditor.010","구분선")}}
          </button>
        </li>
      </ul>
      <!-- 표 버블 메뉴 START -->
      <div class="menubar mock" id="mock_table_bubble_menubar" ref="mock_menubar" style="width: 690px;">
        <span class="table_menus">
          <button class="menubar-button tb-add-btn1"
            @mousedown="setTableBubbleActive(tableCommands.addRowBefore, null)"> 
            {{$i18nUtil.trans("message.ContentBlockTypeContent.004","상단행")}} 
          </button>
          <button class="menubar-button tb-add-btn2"
            @mousedown="setTableBubbleActive(tableCommands.addRowAfter, null)"> 
            {{$i18nUtil.trans("message.ContentBlockTypeContent.005","하단행")}} 
          </button>
          <button class="menubar-button tb-add-btn3"
            @mousedown="setTableBubbleActive(tableCommands.deleteRow, null)"> 
            {{$i18nUtil.trans("message.ContentBlockTypeContent.006","행삭제")}} 
          </button>
          <div class="div"></div>
          <button class="menubar-button tb-add-btn4"
            @mousedown="setTableBubbleActive(tableCommands.addColumnBefore, null)"> 
            {{$i18nUtil.trans("message.ContentBlockTypeContent.007","좌측열")}}
          </button>
          <button class="menubar-button tb-add-btn5"
            @mousedown="setTableBubbleActive(tableCommands.addColumnAfter, null)"> 
            {{$i18nUtil.trans("message.ContentBlockTypeContent.008","우측열")}} 
          </button>
          <button class="menubar-button tb-add-btn6"
            @mousedown="setTableBubbleActive(tableCommands.deleteColumn, null)"> 
            {{$i18nUtil.trans("message.ContentBlockTypeContent.009","열삭제")}} 
          </button>
          <div class="div"></div>
          <button class="menubar-button tb-add-btn7"
            @mousedown="setTableBubbleActive(tableCommands.toggleCellMerge, null)"> 
            {{$i18nUtil.trans("message.ContentBlockTypeContent.010","셀병합")}} 
          </button>
          <!-- <button class="menubar-button tb-add-btn8"> 셀분할 </button> -->
          <button class="menubar-button tb-add-btn9" 
            slot="trigger" ref="tableColorPickerBtn"
            @mousemove="showColorPicker(1)"
            @mouseout="showColorPicker(0)"
          >
            {{$i18nUtil.trans("message.ContentBlockTypeContent.014","셀배경")}}
          </button>
          <div ref="tableColorPickerBdy" 
            class="hidden" 
            @mousemove="showColorPicker(1)"
            @mouseout="showColorPicker(0)"
            style="position:absolute; left:365px; top:-85px;">
            <div class="vue-swatches__container clear col-4" style="position:relative;">
              <button class="tableColorPicker"
                @click="setColorFromPicker($event, c, tableCommands)"
                v-for="(c, inx) in swatches"
                :key="inx"
                :class="'hw-table-cell-color-bg-' + inx + ' ' + (isSetColor(c) ? 'active' : '')">
              </button>
            </div>
          </div>
          <div class="div"></div>
          <button class="menubar-button tb-add-btn10"
            @mousedown="setTableBubbleActive(null, 'bold')">
            {{$i18nUtil.trans("message.ContentBlockTypeContent.015","볼드")}} 
          </button>
          <button class="menubar-button tb-add-btn11"
            @mousedown="setTableBubbleActive(null, 'italic')"> 
            {{$i18nUtil.trans("message.ContentBlockTypeContent.016","이탤릭")}} 
          </button>
          <button class="menubar-button tb-add-btn12"
            @mousedown="setTableBubbleActive(null, 'strike')"> 
            {{$i18nUtil.trans("message.ContentBlockTypeContent.017","취소선")}} 
          </button>
          <button class="menubar-button tb-add-btn13"
            @mousedown="setTableBubbleActive(null, 'underline')"> 
            {{$i18nUtil.trans("message.ContentBlockTypeContent.018","언더라인")}} 
          </button>
          <div class="div"></div>
          <button class="menubar-button tb-add-btn14"
            @mousedown="setTableBubbleActive(null, 'deleteBlock')"> 
            {{$i18nUtil.trans("message.ContentBlockTypeContent.011","표삭제")}} 
          </button>
        </span>
      </div>
      <!-- 표 버블 메뉴 END -->
    </div>
    <!-- /[하단툴바 영역] -->
    <div class="hidden">
      <input ref="localFilePick" type="file" @change="pickupLocalFile"/>
    </div>
    <div id="file-drop-zone" class="hidden">
      <div class="background"></div>
      <div class="cursor"></div>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
/* 드래그&드롭 */
import draggable from "vuedraggable";
/* 날자선택기 */
import Datepicker from "vuejs-datepicker";
/* 블럭편집기 / 타입별로 구분 */
import ContentBlockContext from "../editor/ContentBlockContext";
import ContentBlockTypeContent from "../editor/ContentBlockTypeContent";
import ContentBlockTypeFile from "../editor/ContentBlockTypeFile";
import ContentBlockTypeImage from "../editor/ContentBlockTypeImage";
import ContentBlockTypeLink from "../editor/ContentBlockTypeLink";
import ContentBlockTypeLine from "../editor/ContentBlockTypeLine";
import ContentBlockTypeTodo from "../editor/ContentBlockTypeTodo";
import ContentBlockTypeDecision from "../editor/ContentBlockTypeDecision";
import ContentBlockTypeNull from "../editor/ContentBlockTypeNull";
/* 구글드라이브 */
import GoogleDrive from "../extensions/GoogleDrive";
/* 이벤트 핸들링용 */
import lodash from "lodash";
/* 파일첨부 모달 */
import FileModal from "../modal/FileModal";
/* 표만들기 모달 */
import TableModal from "../modal/TableModal";
/* 링크 입력 모달 */
import URLModal from "../modal/URLModal";
/* 이벤트버스 */
import EventBus from "@/js/eventbus/eventBus";
/* 일반 메시지 모달창 */
import SimpleModal from '../modal/SimpleModal.vue';
import Vue from 'vue';
/* 태그 설정 */
import setTagsModal from "../modal/SetTagsModal";
import axios from "axios";
/* 캘린더 */
import MAS_Cal from "@/components/cowork/general/calendar/modal/MAS_Cal";

export default {
  components: {
    Datepicker,
    draggable,
    GoogleDrive: GoogleDrive
  },
  props: {
    blockInfo: Object,
    category: Object,
    paperInfo: Object,
    startDay: String,
    endDay: String,
    projectInfo: Object,
    boardMemberInfo: Object,
    paperStatus: String,
    lastUpdInfo: Object,
    transmitter: Object,
    userInfo: Object,
    paperLockYn: String,
    superiorMgrYn: String,
    todoSelectedblockId: String,
    boardSection: Array,
    memberSelector: Object,
    boardUtil: Object,
    isRoute: Boolean
  },
  data() {
    return {
      blockCount : 1,
      tenantId: localStorage.getItem("tenantId"),
      show: false,
      deletedIndex: -1,
      reconnectionFunc: null,
      state: {
        tenantId: localStorage.getItem("tenantId"),
        kbdIntrProcs: {},
        focusedBlockType: false,
      },
      dBHeight: {
        "min-height": window.innerHeight + "px"
      },
      dragOptions: {
        animation: 100,
        filter: ".disabled"
      },
      dateFormat: "yyyy.MM.dd",
      getStartDay: "",
      getEndDay: "",
      gapiKeys: {},
      colors: this.boardUtil.colors,
      paperBlockMap: this.blockInfo.paperBlockMap,
      paperBlockIdList: this.blockInfo.paperBlockIdList,
      paperBlockTriggers: {},
      blockContext: ContentBlockContext,
      /* Tag */
      boardHashTagUse: localStorage.getItem("boardHashTagUse") === "true" ? true : false,
      selectedTags: [],
      selectedJobGroup: null,
      /* 표 버블 메뉴 */
      color: this.boardUtil.colors[0],
      swatches: this.boardUtil.colors,
      focusedTableBlockId: null,
      tableCommands: null,
      focusTableActive: {
        function: null,
        param: null,
        click: 0 /* 이벤트 전달을 위한 무의미한 변수 */
      },
      showTableBubbleMenu: false,

      announcementUseYn : localStorage.getItem("announcementUseYn") == "true"? true : false,
      firstBoardEnter : true,

      paperTitleModifyUseYn : false,
      titleLockYn : true
    };
  },
  created() {
    /* 다국어 테스트용 */
    // this.$i18n.locale = "en";

    /* 보드유틸 메소드 추가 */
    let util = this.boardUtil;
    let types = util.blockTypes;
    let typeMap = { };
    typeMap[types.CONTENT] = ContentBlockTypeContent;
    typeMap[types.FILE] = ContentBlockTypeFile;
    typeMap[types.IMAGE] = ContentBlockTypeImage;
    typeMap[types.IMAGELINK] = ContentBlockTypeImage;
    typeMap[types.TODO] = ContentBlockTypeTodo;
    typeMap[types.DECISION] = ContentBlockTypeDecision;
    typeMap[types.LINE] = ContentBlockTypeLine;
    typeMap[""] = ContentBlockTypeNull;
    util.initBoardEditor(this, typeMap);

    /* 컨텐트블럭에 대한 컨텍스트 초기화 */
    this.blockContext.initBoardEditor(this, EventBus, SimpleModal);
    this.blockInfo.context = this.blockContext;

    EventBus.$off("returnSelectedTags");
    EventBus.$on("returnSelectedTags", (param) => {
      if(param.tagList.length > 0) {
        this.updateTag(param);        
      }
    });

    this.titleModifyLockYn();
  },
  mounted() {
    let self = this;
    let util = this.boardUtil;
    this.transmitter.subscribers["BTAB"] = {
      subscribe: function(command, data, error) {
        if (command === "paperBlockList") {
          self.paperBlockSubscribe(data, error);
          return true;
        }
        else if (command === "paperBlockIdList") {
          self.paperBlockIdSubscribe(data, error);
          return true;
        }
        return false;
      }
    };
    util.genColorStyle();
    this.getGoogleApiKey();
    this.getCommentCounts();
    this.HIDE_CURSOR_DATEPICKER({self: this});
    window.removeEventListener("keydown", this.boardKeyDown);
    window.addEventListener("keydown", this.boardKeyDown);

    //boardHashTagUse Check 
    if(this.boardHashTagUse){
      this.getPaperTagList();
    }
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.boardKeyDown);
    if(this.setNotiBoardBlockId != null || this.notiBoardCommentId != null){
      this.setNotiBoardBlockId(null);
      this.setNotiBoardCommentId(null);
    }
  },
  watch: {
    startDay: function () {
      this.getStartDay = this.$props.startDay;
    },
    endDay: function () {
      this.getEndDay = this.$props.endDay;
    },
   "state.focusedBlockType"() { },
   "paperInfo.permission": function(){
    // && this.paperBlockIdList.length == 0
      if(this.announcementUseYn && this.notiBoardBlockId == null) {
        this.boardMouseDown();
      }
   }
  },
  computed:{
    ...mapState("noti", ["notiBoardBlockId","notiBoardCommentId"]),
  },
  methods: {
    ...mapActions("restAction", ["COWORK_REST_ACTION", "COWORK_REST_SIMPLE_ACTION"]),
    ...mapActions("modals", ["showToast"]),
    ...mapActions("coworkUtils", ["HW_KEYGEN", "HIDE_CURSOR_DATEPICKER"]),
    ...mapActions("evdControl", ["CANCEL_EVENT"]),
    ...mapActions("noti", ["setNotiBoardBlockId","setNotiBoardCommentId"]),
    blockMatch(){
      if(this.blockCount == this.paperBlockIdList.length){
        let blockInfo = {
          paperId : this.paperInfo.paperId,
          paperBlockId : this.notiBoardBlockId
        }
        EventBus.$emit("contentBlockMatched", blockInfo);
        if(this.notiBoardCommentId != null){
          this.viewComment(blockInfo);
        }
        this.blockCount = 1;
      }else{
        this.blockCount++;
      }
    },
    /* 보드 저장 */
    saveBoard() {
      // 유효성 검사 실패한 경우 blur 이벤트시에도 저장안되도록 함. 
      if(!this.$refs.titleInputError.classList.contains("hidden")) {
        return;
      }
      this.$emit("saveBoard");
    },
    onTitleInputKey(e) {
      let value = e.target.value;
      // 빈값 체크
      if (value.length == 0) {
        let msg = this.$i18nUtil.trans('UB011');
        this.$refs.titleInputError.innerHTML = msg;
        this.$refs.titleInputError.classList.remove("hidden");
        return;
      }
      // byte 체크 getComByteLength => byteFunction.js에 존재함.
      else if (this.getComByteLength(value) > 60) {
        let msg = this.$i18nUtil.trans('UB008', {textLength: value.length, byteLength: this.getComByteLength(value), maxByteLength: 60});
        this.$refs.titleInputError.innerHTML = msg;
        this.$refs.titleInputError.classList.remove("hidden");
        return;
      }
      else {
        this.$refs.titleInputError.classList.add("hidden");
      }
      if (e.keyCode == this.boardUtil.keyCodes.ENTER) {
        this.saveBoard();
      }
    },
    /* 드래그&드랍 처리 */
    handleDrop(e) {
      let self = this;
      let inx1 = e.oldDraggableIndex;
      let inx2 = e.newDraggableIndex;
      let blockList = self.paperBlockIdList;
      if (inx1 != inx2) {
        /* 이동후 위치가 다른경우 (움직인 경우) */
        let block1 = blockList[inx1];
        let block2 = blockList[inx2];
        this.$emit("moveSortBlock", {
          paperId: this.paperInfo.paperId,
          blockId1: block1,
          blockId2: block2
        });
        if (inx1 < inx2) {
          blockList.splice(inx1, 1);
          blockList.splice(inx2, 0, block1);
        } else {
          blockList.splice(inx2, 1);
          blockList.splice(inx1, 0, block2);
        }
      }
      else {
        /* 이동후 위치가 같은경우 (같은 위치로 움직인 경우) */
      }
      /* 블럭편집기 드래그 상태 취소  */
      self.$refs.contentBlocks[inx1].dragBlockState(0);
      self.$refs.contentBlocks[inx2].dragBlockState(0);
    },
    /* 구글API 키값들을 설정에서 받아온다. */
    getGoogleApiKey() {
      // let self = this;
      // let request = {
      //   url: "/api/copaper/paperblock/getGapiKeys",
      //   req: { },
      //   method: "post",
      // };
      // self.COWORK_REST_ACTION(request)
      //   .then(resp => {
      //     let res = { };
      //     if (resp.errorCode) { 
      //       console.log("/commentCountBlocks error", resp.errorCode); 
      //     }
      //     if (res = self.boardUtil.hasSub(resp, ["result"])) {
      //       for (let key in res) {
      //         self.gapiKeys[key] = res[key];
      //       }
      //     }
      //   }).catch(err => { console.log(err); });
    },
    /* 의견갯수 조회 */
    getCommentCounts() {
      let self = this;
      let request = {
        url: "/api/copaper/opinion/commentCountBlocks",
        req: { paperId: String(self.paperInfo.paperId) },
        method: "post",
      };
      self.COWORK_REST_ACTION(request)
        .then(resp => {
          let res = { };
          if (resp.errorCode) { 
            console.log("/commentCountBlocks error", resp.errorCode); 
          }
          if (res = self.boardUtil.hasSub(resp, ["result"])) {
            res.forEach(item => {
              self.blockInfo.commentCounts[item.paperBlockId] = item.count;
            });
          }
        }).catch(err => { console.log(err); });
    },
    dateReset() {
      this.getStartDay = "";
      this.getEndDay = "";
      this.changePaperPeriod("startDay");
    },
    /* 의견조회 */
    viewComment(bdata) {
      let self = this;
      /* 블럭의견 오픈시 전체의견을 닫아준다 */
      self.paperAllComment(false);
      if (self.blockInfo.commentSelectId != bdata.paperBlockId) {
        self.blockInfo.commentSelectId = "";
        setTimeout(() => {
          self.blockInfo.commentSelectId = bdata.paperBlockId;
        }, 500);
      } else {
        self.blockInfo.commentSelectId = "";
      }
    },
    paperAllComment(show) {
      this.$emit("paperAllComment", show);
    },
    /* STOMP 에서 넘겨받은 데이터 처리 */
    paperBlockSubscribe(paperBlockData, error) {
      // console.log("SUBSCRIBED!", paperBlockData.list.length, this.paperBlockIdList.length);
      // console.log(paperBlockData);
      let self = this;
      let util = self.boardUtil;
      let updateToken = paperBlockData.updateToken;
      let paperBlockList = paperBlockData.list;
      let blockLockList = paperBlockData.lock;
      /* 정렬블럭 */
      let blkSort = [];
      /* 삭제블럭 */
      let blkDel = [];
      /* */
      let blkMap = {};
      let blocks = this.$refs.contentBlocks;
      let lockMap = {};
      let editingMap = this.blockInfo.editingMap;
      let res = [];

      let toastMsg = "";
      if (error.code == "UPLOAD_FAILED") {
        if (error.message == "COFILE_FILE_UPLOAD_FAIL") {
          toastMsg = self.$i18nUtil.trans("TB102"); // 파일 업로드가 실패하였습니다.
        }
        else if (error.message == "COFILE_FILE_UPLOAD_DISALLOW_BY_CDR") {
          toastMsg = self.$i18nUtil.trans("TB104"); // 파일 정보 이상으로 업로드가 차단되었습니다.
        }
        console.log(JSON.stringify(error));
      }
      else if (error.code == "REPLACE_FAILED") {
        if (error.message == "COFILE_FILE_REPLACE_FAIL") {
          toastMsg = self.$i18nUtil.trans("TB103"); // 파일 교체가 실패하였습니다.
        }
        else if (error.message == "COFILE_FILE_UPLOAD_DISALLOW_BY_CDR") {
          toastMsg = self.$i18nUtil.trans("TB104"); // 파일 정보 이상으로 업로드가 차단되었습니다.
        }
        console.log(JSON.stringify(error));
      }
      else if (error.code == "FAILED") {
        toastMsg = self.$i18nUtil.trans("message.BoardEditor.011","오류가 발생하였습니다.");
        console.log(error.message);
      }
      if (toastMsg) {
        let toastInfo = {
          obj: this.$toasted,
          message: toastMsg,
          options: { theme: "toasted-primary", position: "bottom-left", duration: 3000, },
        };
        self.showToast(toastInfo);
      }

      if (updateToken && util.findUpdateToken(updateToken) != -1) {
        /* 전파자가 보낸신호는 되받지 않음 */
        util.removeUpdateToken(updateToken);
        // console.log("PASS! SENDER MESSAGE");
        return;
      }

      for (let k in editingMap) {
        delete editingMap[k];
      }

      /* 락정보 */
      for (let binx = 0; binx < blockLockList.length; binx++) {
        let item = blockLockList[binx];
        lockMap[item.paperBlockId] = item;
        editingMap[item.blockLockId] = item;
      }
      if (self.paperBlockIdList.length == 0) {
        /* 최초에 받아오는 블럭들은 정렬등을 하지 않는다 */
        for (let binx = 0; binx < paperBlockList.length; binx++) {
          let block = paperBlockList[binx];
          let paperBlockId = block.paperBlockId;
          self.paperBlockIdList.splice(binx, 0, paperBlockId);
          self.paperBlockMap[paperBlockId] = {
            bdata: block,
            component: self.paperBlockTypedComponent(block)
          };
          /* 최초에 받아오는 블럭들의 본인 lock초기화 */
          if ((block.blockType === self.BTPS().CONTENT || block.blockType === self.BTPS().TABLE) &&
            lockMap[paperBlockId] && lockMap[paperBlockId].blockLockId === self.userInfo.userId) {
            delete lockMap[paperBlockId];
            delete editingMap[paperBlockId];
            self.HW_KEYGEN({head: "UPDT", res});
            let updateToken = res[0];
            self.boardUtil.addUpdateToken(updateToken);
            let param = {
              uri: "/block/blockLockYn",
              param: {
                paperId: String(self.paperInfo.paperId),
                paperBlockId: paperBlockId,
                blockLockYn: "0",
                updateToken: updateToken
              }
            }
            self.boardUtil.apiCall(param);
          }
        }
      }
      else {
        /* 새 블럭리스트를 사용하여 정렬블럭을 구성 */
        for (let binx = 0; binx < paperBlockList.length; binx++) {
          let block = paperBlockList[binx];
          /* 임시 삭제한 블럭이 뒤늦게 stomp를 타고 들어오는경우 삭제*/
          if (self.blockInfo.deletedBlocks.indexOf(block.paperBlockId) == -1) {
            blkSort.push(block.paperBlockId);
            blkMap[block.paperBlockId] = block;
          }
        }
        /* 임시삭제 블럭 초기화 */
        self.blockInfo.deletedBlocks.splice(0, self.blockInfo.deletedBlocks.length);

        /**
         * 삭제할 블럭 찾기
         * 블럭 리스트를 받을 때 임시블럭 등이 생성되면 생성과 동시에 삭제후보에 
         * 들어갈수 있다.
         **/
        for (let binx = 0; binx < self.paperBlockIdList.length; binx++) {
          let blockId = self.paperBlockIdList[binx];
          let dinx = blkSort.indexOf(blockId);
          if (dinx == -1) {
            blkDel.push(blockId);
          }
        }

        blkSort.sort((blockId1, blockId2) => {
          return blkMap[blockId1].sortNo - blkMap[blockId2].sortNo;
        });
        /* 먼저 삭제된 블럭을 처리해준다 */
        for (let binx = 0; binx < blkDel.length; binx++) {
          let blockId = blkDel[binx];
          let dinx = self.paperBlockIdList.indexOf(blockId);
          if (dinx != -1) {
            self.paperBlockIdList.splice(dinx, 1);
            util.removeBlockData(blockId);
          }
        }

        /* 새로생성된 블럭과 업데이트 할 블럭을 나누어 처리한다 */
        for (let binx = 0; binx < blkSort.length; binx++) {
          let paperBlockId = blkSort[binx];
          let ninx = self.paperBlockIdList.indexOf(paperBlockId);
          let map = self.paperBlockMap[paperBlockId];
          if (map && ninx != -1) {
            let bdata = map.bdata;
            let element = map.element;
            bdata.sortNo = blkMap[paperBlockId].sortNo;

            self.paperBlockIdList.splice(ninx, 1);
            self.paperBlockIdList.splice(binx, 0, paperBlockId);
            if (element) {
              if (element.checkLockOwn() == self.OTPS().OWNER) { }
              element.dragBlockState(0);
            }
          }
          else {
            self.paperBlockMap[paperBlockId] = {
              bdata: blkMap[paperBlockId],
              component: self.paperBlockTypedComponent(blkMap[paperBlockId])
            };
            self.paperBlockIdList.splice(binx, 0, paperBlockId);
          }
        }
      }
      // console.log("LOCKMAP:", lockMap);
      for (let binx = 0; binx < self.paperBlockIdList.length; binx++) {
        let bdata = self.paperBlockMap[self.paperBlockIdList[binx]].bdata;
        let lockInfo = null;
        if ((lockInfo = lockMap[bdata.paperBlockId])) {
          // console.log("LOCKINFO:", lockInfo);
          bdata.blockLockYn = 1;
          bdata.blockLockId = lockInfo.blockLockId;
          bdata.blockLockName = lockInfo.blockLockName;
          bdata.blockLockNameEn = lockInfo.blockLockNameEn;
        }
        else {
          bdata.blockLockYn = 0;
          bdata.blockLockId = null;
          bdata.blockLockName = null;
          bdata.blockLockNameEn = null;
        }

        /* 블럭의 트리거 함수가 있다면 실행시켜 준다 */
        let triggers =  self.paperBlockTriggers[bdata.paperBlockId];
        // console.log("TRIGGERS:", triggers ? triggers.length : 0);
        while (triggers && triggers.length > 0) {
          // console.log("LAUNCH TRIGGER:", bdata.paperBlockId);
          let trigger = triggers.splice(0, 1);
          setTimeout(trigger, 100);
        }
      }

      util.domCreated();
    },
    /**
     * 블럭데이터를 스트리밍 처리하기 위해 우선은 전체 블럭 ID만 받아온 후 
     * 필요한 ID정보를 요청하여 본문정보를 다시 받아오는 방식을 구현한다.
     * 웹소켓으로는 ID목록만 Kafka를 통해 전파(1:N Broadcasting) 받고 본문정보는 
     * 직접 REST API 를 통해 받는다 (송수신 포인트가 1:1로 확정되어 있으므로)
     * NOTE: 백엔드에서 신호를 주지 않으므로 현재는 작동하지 않는 코드임
     **/
    paperBlockIdSubscribe(paperBlockIdData, error) {
      // console.log("SUBSCRIBED!", paperBlockIdData.list.length, this.paperBlockIdList.length);
      // console.log(paperBlockIdData);
      // if (!paperBlockIdData.list) { paperBlockIdData = { list: paperBlockIdData, lock: [] }; }
      let self = this;
      let util = self.boardUtil;
      let updateToken = paperBlockIdData.updateToken;
      let paperBlockIdList = paperBlockIdData.list;
      let blockLockList = paperBlockIdData.lock;
      /* 정렬블럭 */
      let blkSort = [];
      /* 삭제블럭 */
      let blkDel = [];
      /* */
      let blkMap = {};
      let lockMap = {};
      let editingMap = self.blockInfo.editingMap;

      let toastMsg = "";
      if (error.code == "UPLOAD_FAILED") {
        if (error.message == "COFILE_FILE_UPLOAD_FAIL") {
          toastMsg = self.$i18nUtil.trans("TB102"); // 파일 업로드가 실패하였습니다.
        }
        else if (error.message == "COFILE_FILE_UPLOAD_DISALLOW_BY_CDR") {
          toastMsg = self.$i18nUtil.trans("TB104"); // 파일 정보 이상으로 업로드가 차단되었습니다.
        }
        console.log(JSON.stringify(error));
      }
      else if (error.code == "REPLACE_FAILED") {
        if (error.message == "COFILE_FILE_REPLACE_FAIL") {
          toastMsg = self.$i18nUtil.trans("TB103"); // 파일 교체가 실패하였습니다.
        }
        else if (error.message == "COFILE_FILE_UPLOAD_DISALLOW_BY_CDR") {
          toastMsg = self.$i18nUtil.trans("TB104"); // 파일 정보 이상으로 업로드가 차단되었습니다.
        }
        console.log(JSON.stringify(error));
      }
      else if (error.code == "FAILED") {
        toastMsg = self.$i18nUtil.trans("message.BoardEditor.011","오류가 발생하였습니다.");
        console.log(error.message);
      }
      if (toastMsg) {
        let toastInfo = {
          obj: self.$toasted,
          message: toastMsg,
          options: { theme: "toasted-primary", position: "bottom-left", duration: 3000, },
        };
        self.showToast(toastInfo);
      }

      if (updateToken && util.findUpdateToken(updateToken) != -1) {
        /* 전파자가 보낸신호는 되받지 않음 */
        util.removeUpdateToken(updateToken);
        // console.log("PASS! SENDER MESSAGE");
        return;
      }

      for (let k in editingMap) {
        delete editingMap[k];
      }

      /* 락정보 */
      for (let binx = 0; binx < blockLockList.length; binx++) {
        let item = blockLockList[binx];
        lockMap[item.paperBlockId] = item;
        editingMap[item.blockLockId] = item;
      }
      if (self.paperBlockIdList.length == 0) {
        /* 최초에 받아오는 블럭들은 정렬등을 하지 않는다 */
        for (let binx = 0; binx < paperBlockIdList.length; binx++) {
          let block = paperBlockIdList[binx];
          let paperBlockId = block[0];
          self.paperBlockIdList.splice(binx, 0, paperBlockId);
          self.paperBlockMap[paperBlockId] = {
            bdata: {
              paperBlockId : block[0],
              sortNo : block[1],
              blockState : block[2],
            },
            component: ContentBlockTypeNull
          }
        }
      }
      else {
        /* 새 블럭리스트를 사용하여 정렬블럭을 구성 */
        for (let binx = 0; binx < paperBlockIdList.length; binx++) {
          let block = paperBlockIdList[binx];
          /* 임시 삭제한 블럭이 뒤늦게 stomp를 타고 들어오는경우 삭제*/
          if (self.blockInfo.deletedBlocks.indexOf(block[0]) == -1) {
            blkSort.push(block[0]);
            blkMap[block[0]] = {
              paperBlockId : block[0],
              sortNo : block[1],
              blockState : block[2],
            };
          }
        }
        /* 임시삭제 블럭 초기화 */
        self.blockInfo.deletedBlocks.splice(0, self.blockInfo.deletedBlocks.length);

        /**
         * 삭제할 블럭 찾기
         * 블럭 리스트를 받을 때 임시블럭 등이 생성되면 생성과 동시에 삭제후보에 
         * 들어갈수 있다.
         **/
        for (let binx = 0; binx < self.paperBlockIdList.length; binx++) {
          let blockId = self.paperBlockIdList[binx];
          let dinx = blkSort.indexOf(blockId);
          if (dinx == -1) {
            blkDel.push(blockId);
          }
        }

        blkSort.sort((blockId1, blockId2) => {
          return blkMap[blockId1].sortNo - blkMap[blockId2].sortNo;
        });
        /* 먼저 삭제된 블럭을 처리해준다 */
        for (let binx = 0; binx < blkDel.length; binx++) {
          let blockId = blkDel[binx];
          let dinx = self.paperBlockIdList.indexOf(blockId);
          if (dinx != -1) {
            self.paperBlockIdList.splice(dinx, 1);
            util.removeBlockData(blockId);
          }
        }

        /* 새로생성된 블럭과 업데이트 할 블럭을 나누어 처리한다 */
        for (let binx = 0; binx < blkSort.length; binx++) {
          let paperBlockId = blkSort[binx];
          let ninx = self.paperBlockIdList.indexOf(paperBlockId);
          let map = self.paperBlockMap[paperBlockId];
          if (map && ninx != -1) {
            let bdata = map.bdata;
            let element = map.element;
            bdata.sortNo = blkMap[paperBlockId].sortNo;

            self.paperBlockIdList.splice(ninx, 1);
            self.paperBlockIdList.splice(binx, 0, paperBlockId);
            if (element) {
              if (element.checkLockOwn() == self.OTPS().OWNER) { }
              element.dragBlockState(0);
            }
          }
          else {
            self.paperBlockMap[paperBlockId] = {
              bdata: blkMap[paperBlockId],
              component: ContentBlockTypeNull
            }
            self.paperBlockIdList.splice(binx, 0, paperBlockId);
          }
        }
      }
      {
        paperBlockIdList = self.paperBlockIdList.slice();
        /* 블럭본문 요청. 5개씩 분할하여 요청한다. */
        const REQSIZE = 5;
        let idList = [];
        let callbackChain = [];
        for (let inx = 0; inx < paperBlockIdList.length; inx++) {
          let paperBlockId = paperBlockIdList[inx];
          let bdata = self.paperBlockMap[paperBlockId].bdata || {};
          let lockInfo = lockMap[paperBlockId];
          /* 현재 점유중인 블럭은 요청하지 않는다. */
          if (lockInfo && lockInfo.blockLockId == self.userInfo.userId) {
              // console.log("LOCK:", lockInfo);
              continue;
          }
          /**
           * 구분선은 별도의 요청이 필요 없다.
           * 텍스트블럭, 테이블블럭 등은 키보드 이벤트로 내용이 전송되므로 별도 요청이 필요 없다.
           **/
          if (bdata.blockType == self.BTPS().LINE ||
            (bdata.blockType == self.BTPS().CONTENT && bdata.contentPath) ||
            (bdata.blockType == self.BTPS().TABLE && bdata.contentPath) ) {
            self.boardUtil.blockDomCreated(bdata.paperBlockId);
            continue;
          }
          idList[idList.length] = paperBlockId;
          if (idList.length == REQSIZE) {
            let arg1 = idList.splice(0, idList.length);
            callbackChain[callbackChain.length] = 
              () => { self.paperBlockContentRequest(arg1, lockMap, callbackChain); };
          }
        }
        if (idList.length > 0) {
          let arg1 = idList.splice(0, idList.length);
          callbackChain[callbackChain.length] = 
            () => { self.paperBlockContentRequest(arg1, lockMap, callbackChain); };
        }
        if (callbackChain && callbackChain.length > 0) {
          setTimeout(callbackChain.splice(0, 1)[0], 1);
        }
      }
    },
    paperBlockContentRequest(idList, lockMap, callbackChain) {
      if (!idList.length) { return; }
      let self = this;
      let editingMap = self.blockInfo.editingMap;
      // console.log("IDARR:", idList);
      let request = {
        url: "/api/copaper/paper/getPaperBlockListBody",
        req: { idList: idList.slice() },
        method: "post",
      };
      self.COWORK_REST_ACTION(request)
        .then(resp => {
          let res = { };
          if (resp.errorCode) { console.log("", resp.errorCode); }
          if (resp && resp.result && resp.result.list) {
            for (let bdata of resp.result.list) {
              // console.log("BLOCK:", bdata);
              let id = bdata.paperBlockId;
              let block = self.paperBlockMap[id];
              if (!lockMap[id]) {
                bdata.blockLockYn = 0;
                bdata.blockLockId = "";
                bdata.blockLockName = "";
                bdata.blockLockNameEn = "";
              }
              for (let k in bdata) { block.bdata[k] = bdata[k]; }
              if (block.component == ContentBlockTypeNull) {
                // console.log("NEW COMPONENT:", id)
                block.component = self.paperBlockTypedComponent(bdata);
                self.paperBlockIdList.splice(self.paperBlockIdList.indexOf(id), 1, id);
              }
              self.boardUtil.blockDomCreated(id);
            }
            for (let ldata of resp.result.lock) {
              let blockId = ldata.paperBlockId;
              let lockId = ldata.blockLockId;
              let lockNm = ldata.blockLockName;
              let lockNmEn = ldata.blockLockNameEn;
              let block = {};
              if ((block = self.paperBlockMap[editingMap[lockId]])) {
                block.bdata.blockLockYn = 0;
                block.bdata.blockLockId = "";
                block.bdata.blockLockName = "";
                block.bdata.blockLockNameEn = "";
              }
              if ((block = self.paperBlockMap[blockId])) {
                block.bdata.blockLockYn = 1;
                block.bdata.blockLockId = lockId;
                block.bdata.blockLockName = lockNm;
                block.bdata.blockLockNameEn = lockNmEn;
              }
            }
          }
          if (callbackChain && callbackChain.length > 0) {
            setTimeout(callbackChain.splice(0, 1)[0], 1);
          }
        }).catch(err => {
          console.log(err);
          if (callbackChain && callbackChain.length > 0) {
            setTimeout(callbackChain.splice(0, 1)[0], 1);
          }
        });
    },
    paperBlockTypedComponent(bdata) {
      // console.log(bdata);
      let self = this;
      let util = self.boardUtil;
      let blockType = bdata.blockType;
      let content = bdata.contentPath;
      let component = null;
      if (blockType === self.BTPS().CONTENT || blockType === self.BTPS().TABLE) {
        component = ContentBlockTypeContent;
      }
      else if (blockType === self.BTPS().IMAGELINK) {
          component = ContentBlockTypeImage;
      }
      else if (blockType === self.BTPS().FILE || blockType === self.BTPS().IMAGE) {
        if (util.fileExt(content)[1] === util.fileTypes.IMAGE) {
          component = ContentBlockTypeImage;
        }
        else {
          component = ContentBlockTypeFile;
        }
      }
      else if (blockType === self.BTPS().LINK) {
        component = ContentBlockTypeLink;
      }
      else if (blockType === self.BTPS().LINE) {
        component = ContentBlockTypeLine;
      }
      else if (blockType === self.BTPS().TODO) {
        component = ContentBlockTypeTodo;
      }
      else if (blockType === self.BTPS().DECISION) {
        component = ContentBlockTypeDecision;
      }
      else {
        component = ContentBlockTypeNull;
      }
      return component;
    },
    /* 현재 포커싱 된 블럭을 찾는다 */
    getCurrentEditable() {
      let ret = null;
      if (this.boardUtil.blockOwned) {
        ret = this.boardUtil.blockOwned;
      }
      else {
        let contentBlocks = this.$refs.contentBlocks;
        if (contentBlocks) {
          ret = contentBlocks[contentBlocks.length - 1];
          for (let inx = 0; inx < contentBlocks.length; inx++) {
            let element = contentBlocks[inx];
            if (element.checkLockOwn() === this.OTPS().OWNER) {
              ret = element;
              break;
            }
          }
        }
      }
      return ret;
    },
    /* 하단 툴바 클릭 이벤트 처리 */
    clickToolbarButton(e) {
      let self = this;
      let element = this.getCurrentEditable();
      console.log("ELEMENT:", element);
      let blockList = this.paperBlockIdList;
      let sortNo = 0;
      if (element && element.bdata) {
        element.cancelBlur();
        sortNo = element.bdata.sortNo;
      }
      else if (blockList.length > 0) {
        sortNo = this.paperBlockMap[blockList[blockList.length - 1]].bdata.sortNo;
      }
      {
        let target = e.target;
        if (!target) {
          return;
        }
        let btnId = e.target.getAttribute("data-btn-id");
        if (!btnId) {
          return;
        }
        if (element && element.state) {
          if (element.state.handleSubmit) {
            clearTimeout(element.state.handleSubmit);
            let caretPos = element.state.caretPos;
            e.target.blur();
            setTimeout(() => {
              self.boardUtil.focusBlock(element, caretPos, true);
            }, 100);
            element.state.caretPos = 0;
          }
          else {
            if (element.blockType() == self.BTPS().CONTENT || element.blockType() == self.BTPS().TABLE) {
              let caretPos = element.editor.state.selection.$anchor.pos;
              e.target.blur();
              setTimeout(() => {
                self.boardUtil.focusBlock(element, caretPos, true);
              }, 100);
            }
          }
          element.state.handleSubmit = -1;
        }

        if (btnId === "btn-add-link") {
          /* 링크 추가 */
          this.requestURLContent(false, element);
        }
        else if (btnId === "btn-add-table") {
          /* 테이블 추가 */
          this.requestTableContent(element);
        }
        else if (btnId === "btn-add-division") {
          /* 가로구분선 추가 */
          this.boardUtil.createTempBlock({ blockType: this.BTPS().LINE, sortNo: sortNo },
            (block) => { });
        }
        else if (btnId === "btn-add-image") {
          /* 이미지 팝업 */
          // this.handleFileUpload("IMAGE", element);
          let fileElem = this.$dm(this.$refs.localFilePick);
          fileElem.value = null;
          fileElem.at("data-file-type", "IMAGE")
            .at("data-sort-no", sortNo);
          fileElem.click();
        }
        else if (btnId === "btn-add-file") {
          /* 파일 팝업 */
          // this.handleFileUpload("FILE", element);
          let fileElem = this.$dm(this.$refs.localFilePick);
          fileElem.value = null;
          fileElem.at("data-file-type", "FILE")
            .at("data-sort-no", sortNo);
          fileElem.click();
        }
        else if (btnId === "btn-add-todo") {
          /* 할 일 */
          /* FIXME: 임시, 기능 완료가 되기 전까지 이전 코드로 원복 */
          // this.todoModalOpen()
          this.boardUtil.createTempBlock({ blockType: this.BTPS().TODO, sortNo: sortNo, content: "" },
            (block) => { });
        }
        else if (btnId === "btn-add-opinion") {
          /* 의사결정 */
          this.boardUtil.createTempBlock({ blockType: this.BTPS().DECISION, sortNo: sortNo, content: "" },
            (block) => { });
        }
        else {
          /* 글머리, 번호 등의 기능은 현재 편집중인 블럭 에디터에서만 가능 */
          let btn = element.$el.querySelector(".menubar ." + btnId);
          if (btn) {
            btn.click();
            delete element.bdata.isTemp;
            element.focus();
          }
          else {
            console.log("menubar btn (" + btnId + ") not found");
          }
        }
      }
    },
    uploadFile(file, sortNo, type, onCreate) {
      this.$emit("setUploadData", [file]);
      let rtnData = {
        data: {
          groupId: this.paperInfo.groupId,
          sortNo: sortNo,
          url: "/api/cofile/paper/registImage",
          sendType: "post",
          uploadType: type
        },
        onCreate: onCreate
      }
      this.$emit("fileUpload", rtnData);
    },
    pickupLocalFile(e) {
      let fileElem = this.$dm(this.$refs.localFilePick);
      if (fileElem.files.length) {
        this.$emit("setUploadData", fileElem.files);
        let type = fileElem.at("data-file-type");
        let blockId = fileElem.at("data-block-id");
        let sortNo = fileElem.at("data-sort-no");
        let rtnData = {
          data: {
            groupId: this.paperInfo.groupId,
            sortNo: sortNo,
            url: "/api/cofile/paper/registImage",
            sendType: "post",
            uploadType: type
          }
        }
        this.$emit("fileUpload", rtnData, fileElem);
      }
    },
    /* 파일 업로드 화면 요청*/
    handleFileUpload(uploadType, element) {
      const modalInfo = {
        obj: this.$modal,
        name: "fileUpload",
        type: "fileUpload",
        title: (uploadType === this.BTPS().IMAGE ? this.$i18nUtil.trans("message.BoardEditor.012","이미지") : this.$i18nUtil.trans("message.BoardContents.001","파일")) + " " + this.$i18nUtil.trans("message.BoardEditor.013","업로드"),
        component: FileModal,
        data: {
          groupId: this.paperInfo.groupId,
          sortNo: element.bdata.sortNo,
          url: "/api/cofile/paper/registImage",
          sendType: "post",
          uploadType: uploadType
        }
      };
      this.showModal(modalInfo);
    },
    /* 파일 업로드 화면 요청*/
    requestURLContent(url, element) {
      let self = this;
      let fncSubmit = null;
      if (url) {
        fncSubmit = function(type, content) {
          element.state.linkMeta.splice(0, 1);
          element.html = element.bdata.contentPath = content;
          element.getContent();
          element.contentBlockAPI("updateBlock");
        };
      }
      else {
        fncSubmit = function(type, content) {
          self.boardUtil.addNewBlock({
            blockType: type,
            contentPath: content,
            sortNo: element.bdata.sortNo
          });
        };
      }
      const modalInfo = {
        obj: this.$modal,
        width: "600px",
        component: URLModal,
        blockType: this.BTPS().LINK,
        content: url,
        fnSubmit: fncSubmit
      };
      this.showModal(modalInfo);
    },
    /* 표생성 화면 요청*/
    requestTableContent(element) {
      let ebody = document.getElementById("content-editor");
      let tbWidth = ebody.offsetWidth;
      let sortNo = 0;
      if (element && element.bdata) {
        sortNo = element.bdata.sortNo;
      }

      const modalInfo = {
        obj: this.$modal,
        width: "800px",
        component: TableModal,
        tbColors: this.boardUtil.colors,
        tbWidth: tbWidth,
        blockType: this.BTPS().TABLE,
        sortNo: sortNo,
        fnSubmit: this.boardUtil.addNewBlock
      };
      this.showModal(modalInfo);
    },
    editorAPI(sendId, param, callback) {
      let self = this;
      let params = {
        addNewBlock: {
          uri: "/block/saveBlock",
          param: {
            paperId: String(self.paperInfo.paperId),
            prevSortNo: param && param.sortNo ? String(param.sortNo) : 0,
            paperBlockId: param && param.paperBlockId ? String(param.paperBlockId) : null,
            blockType: param && param.blockType ? param.blockType : "CONTENT",
            contentPath: param && param.contentPath ? param.contentPath : null,
            blockLockYn: param && !param.blockLockYn ? 0 : 1,
            blockState: param && !param.blockState ? 0 : 1,
            fileId: param && param.fileId ? param.fileId : null,
            updateToken: param && param.updateToken ? param.updateToken : null
          },
          callback: callback
        },
        updateNewBlock: {
          uri: "/block/updateNewBlock",
          param: {
            paperId: String(self.paperInfo.paperId),
            prevSortNo: param && param.sortNo ? String(param.sortNo) : 0,
            paperBlockId: param && param.paperBlockId ? String(param.paperBlockId) : null,
            contentPath: param && param.contentPath ? param.contentPath : null,
            blockType: param && param.blockType ? param.blockType : "CONTENT",
            blockLockYn: param && !param.blockLockYn ? 0 : 1,
            blockLockName: param && param.blockLockName ? param.blockLockName : "",
            blockLockNameEn: param && param.blockLockNameEn ? param.blockLockNameEn : "",
            blockState: param && !param.blockState ? 0 : 1,
            updateToken: param && param.updateToken ? param.updateToken : null
          },
          callback: callback
        }
      };
      this.boardUtil.apiCall(params[sendId]);
    },
    changePaperLockYn(paperLockYn) {
      this.$emit("changePaperLockYn", paperLockYn);
    },
    changePaperSuperiorYn(superiorMgrYn) {
      this.$emit("changePaperSuperiorYn", superiorMgrYn);
    },
    goProjectPage(projectInfo) {
      let obj = this;
      let path = "/general";
      // 과제가 아닌경우
      if(projectInfo == null) {
        // snapshot
        if(obj.paperInfo.categoryInfo == null) {

        }
        else {
          // 프라이빗
          if(obj.paperInfo.categoryInfo.section == null) {
            path += "/private";
            obj.$router.push(path);
          }
          // 정보공유
          else if(obj.paperInfo.categoryInfo.section == "SHAR") {
            let param = {
              categoryName : obj.paperInfo.categoryInfo.categoryName,
              categoryMid : obj.paperInfo.categoryInfo.categoryMid
            }
            window.sessionStorage.setItem("shareInfo", JSON.stringify(param));
            path += "/shareInfo";
            obj.$router.push(path);
            // history.back();
          }
          // 회의/협의체
          else if(obj.paperInfo.categoryInfo.section == "CFRC") {
            let param = {
              categoryName : obj.paperInfo.categoryInfo.categoryName,
              categoryMid : obj.paperInfo.categoryInfo.categoryMid
            }
            window.sessionStorage.setItem("cooperation", JSON.stringify(param));
            path += "/cooperation";
            obj.$router.push(path);
            // history.back();
          }
        }
      }
      // 과제
      else {
        path += "/dashboard/" + projectInfo.projectId;
        obj.$router.push(path);
      }
    },
    changePaperStatus(paperStatus) {
      this.$emit("changePaperStatus", paperStatus);
    },
    changeCategory(item) {
      this.$emit("changeCategory", item);
    },
    showModal(modalInfo) {
      this.$emit("showModal", modalInfo);
    },
    cancelBlur(fnc) {
      let block = this.getCurrentEditable();
      this.boardUtil.blockOwned = block;
      if (block && fnc) {
        block.cancelBlur(fnc);
      }
    },
    googleFileUpload(data) {
      if (data.type === "click") {
        this.$dm(this.$refs.fileMenu).clr("active");
      }
      else if (data.action === "picked") {
        let block = null;
        if (this.boardUtil.blockOwned) {
          block = this.boardUtil.blockOwned;
          this.boardUtil.blockOwned.setDisableEditable();
        }
        if (!block) {
          block = getCurrentEditable();
        }
        let doc = data.docs[0];
        let el = document.createElement("a");
        el.innerText = doc.embedUrl;
        el.setAttribute("data-meta-title", doc.name);
        el.setAttribute("data-meta-image", doc.iconUrl);
        el.setAttribute("data-meta-description", "");
        el.setAttribute("data-meta-linkType", "google");
        // console.log("EL:" + el.outerHTML);
        // console.log("EDITOR-DATA:" + JSON.stringify(block.bdata));
        if (block.bdata) {
          this.boardUtil.addNewBlock({
            paperId: String(this.paperInfo.paperId),
            sortNo: String(block.bdata.sortNo),
            blockType: this.BTPS().LINK,
            contentPath: el.outerHTML
          });
        }
      }
    },
    changePaperPeriod(sourceDatePickerId) {
      /* 기간정보 수정 */
      this.$emit("changePaperPeriod", {targetId: sourceDatePickerId, startDay: this.getStartDay, endDay: this.getEndDay});
    },
    contentText(html) {
      let element = document.createElement("div");
      element.innerHTML = html;
      let text = element.innerText.replace(/[ \t\r\n]*/gi, "");
      return text;
    },
    boardDragDropFile(e, type) {
      let self = this;
      let blockMap = null;
      let editor = self.$el.querySelector("#content-editor");
      let dropZone = self.$el.querySelector("#file-drop-zone");
      dropZone.style.width = editor.offsetWidth + "px";
      dropZone.style.height = (editor.offsetHeight + 50) + "px";
      dropZone.style.top = editor.offsetTop + "px";
      dropZone.style.left = editor.offsetLeft + "px";

      if (e.dataTransfer && e.dataTransfer.types && e.dataTransfer.types[0] === "Files") {
        if (type === "drop" && e.dataTransfer.files) {
          dropZone.classList.add("hidden");
          blockMap = self.findBlockByCursor(e);
          if (blockMap) {
            // console.log("BLOCKID:", JSON.stringify(blockMap.bdata));
            // console.log(e.dataTransfer.files[0]);
            this.$emit("setUploadData", e.dataTransfer.files);
            let blockId = blockMap.bdata.paperBlockId;
            let blockList = this.paperBlockIdList;
            let sortNo = 0;
            if (this.paperBlockMap[blockId]) {
              sortNo = this.paperBlockMap[blockId].bdata.sortNo;
            }
            else if (blockList.length > 0) {
              sortNo = this.paperBlockMap[blockList[blockList.length - 1]].bdata.sortNo;
            }
            let rtnData = {
              data: {
                groupId: this.paperInfo.groupId,
                sortNo: sortNo,
                url: "/api/cofile/paper/registImage",
                sendType: "post",
                uploadType: self.BTPS().FILE
              }
            }
            this.$emit("fileUpload", rtnData);
          }
        }
        else if (type === "leave") {
          let leaveHandle = dropZone.getAttribute("leave-handle");
          if (leaveHandle) { clearTimeout(leaveHandle); }
          leaveHandle = setTimeout(() => { dropZone.classList.add("hidden"); }, 250);
          dropZone.setAttribute("leave-handle", leaveHandle);
        }
        else if (type === "over") {
          let leaveHandle = dropZone.getAttribute("leave-handle");
          if (leaveHandle) { clearTimeout(leaveHandle); }
          lodash.throttle(() => {
            dropZone.classList.remove("hidden");
            blockMap = self.findBlockByCursor(e);
            if (blockMap) {
              let el = blockMap.element.$el;
              let top = el.offsetTop + el.offsetHeight - editor.offsetTop + 3;
              dropZone.querySelector(".cursor").style.top = top + "px";
            }
          }, 100)();
        }
        else {

        }
        self.CANCEL_EVENT({event: e});
      }
    },
    boardKeyDown(e) {
      let self = this;
      let block = self.boardUtil.blockOwned;
      if (block && block.blockType() == self.BTPS().LINE &&
        (e.keyCode == self.boardUtil.keyCodes.DEL ||
         e.keyCode == self.boardUtil.keyCodes.BS)) {
        self.boardUtil.removeBlockData(block.bdata.paperBlockId);
        block.deleteBlock({ callback(res) { }});
      }
    },
    boardMouseDown(e) {
      if (this.paperInfo.permission < 2) {
        if(e) {
          e.preventDefault();
          e.stopPropagation();
        }
        /* 읽기전용 */
        return;
      }
      this.boardMouseDownWrapper(e);
    },
    boardMouseDownWrapper: lodash.throttle(
      function(e) {
      let self = this;
      let BTPS = self.BTPS();
      let util = self.boardUtil;
      // let elem = e.target;

      // highlifht 있는 블럭 highlight 제거
      let data = {
        paperId:self.paperInfo.paperId
      }
      EventBus.$emit("removeBlockHighlight", data);
      // 보드 재 진입시 하이라이트 생기지 않도록 초기화.
      self.setNotiBoardBlockId(null);
      self.setNotiBoardCommentId(null);

      /* 
        손해보험 : 보드 진입시 최초 진입 / 보드의 블럭이 없을경우 
                  빈블럭생성후 포커싱 하기위함. 
                  watch 에  "paperInfo.permission" 에서 분기처리.
      */    
      let elem = null;
      if(e != null) {
        elem = e.target;
      } else {
        elem = self.$el.querySelector("#content-editor");
      }
      if (util.blockOwned) {
        let block = util.blockOwned;
        util.blurPrevFocusedBlock(util.blockOwned);
        util.blockOwned = false;
        if (block.blockType() == self.BTPS().LINE) {
          block.state.focused = false;
        }
      }
      if (!(elem && elem.nodeName == "BUTTON" && elem.parentNode.parentNode.classList.contains("edit_tool"))) {
        self.state.focusedBlockType = "";
      }
      if (elem && elem.nodeName == "INPUT" && elem.getAttribute("type") == "text") { /* 제목입력란 */ }
      else if (elem && elem.getAttribute("id") === "content-editor") {
        /* 에디터블럭이 아닌경우 강제로 에디터를 생성해 준다 */
        let blocks = self.$refs.contentBlocks;
        let body = document.querySelector("#app .hw_wrap .board-content");

        if(this.announcementUseYn && this.firstBoardEnter && this.notiBoardBlockId == null){
          self.tracelog("CREATE-TEMP:0");
          this.firstBoardEnter = false;
          util.createTempBlock({ sortNo: 0, content: "" }, (block) => {
            util.blurPrevFocusedBlock(block);
            util.focusBlock(block, 0, true);
            util.blockOwned = block;
            block.bdata.isTemp = true;
            block.$refs.buttonComment.firstChild.classList.add("hidden");
            self.state.focusedBlockType = block.blockType();
          });
        }else{
          if (blocks && blocks.length > 0) {
            this.boardUtil.sortPaperBlocks(1);
            let clientY = e.clientY;
            let scrollTop = (window.scrollY || window.pageYOffset) + body.scrollTop;
            let einx = 0;
            let sortNo = 0;
  /**
   * 마우스 찍는 위치와 블럭의 위치를 시각적으로 보여줄 수 있는 코드
   */
  // {
  //   let markers = document.querySelectorAll("div.color_marking");
  //   let body = document.querySelector("#app .hw_wrap .board-content");
  //   // let keys = "";
  //   // for (let key in body) { keys += " " + key; }
  //   // console.log("BODY:", keys);
  //   console.log("BODY:", body.scrollTop);
  //   for (let marker of markers) { body.removeChild(marker); }
  //   let div = document.createElement("div");
  //   div.innerHTML = ".";
  //   div.className = "color_marking";
  //   div.style = "position:absolute;background:blue;width:10px;height:10px;left:200px;";
  //   div.style.top = (clientY + scrollTop) + "px";
  //   body.appendChild(div);
  // }
            for (; einx < blocks.length; einx++) {
              let element = blocks[einx].$el;
              blocks[einx].bdata.index = einx;
              // console.log("INDEX:", einx, clientY, scrollTop, (clientY + scrollTop), element.offsetTop, element);
  
  // {
  //   let body = document.querySelector("#app .hw_wrap .board-content");
  //   let div = document.createElement("div");
  //   div.innerHTML = ".";
  //   div.className = "color_marking";
  //   div.style = "position:absolute;background:red;width:10px;height:10px;left:300px;";
  //   div.style.top = element.offsetTop + "px";
  //   body.appendChild(div);
  // }
              if (clientY + scrollTop < element.offsetTop) {
                self.tracelog("INDEX:", einx, clientY, scrollTop, element.offsetTop);
                break;
              }
            }
            if (einx >= 0) {
              let block = null;
              let typePrev = null;
              let typeNext = null;
              if (einx > 0) {
                block = blocks[einx - 1];
                sortNo = block.bdata.sortNo;
                typePrev = block.bdata.blockType;
              }
              if (einx < blocks.length) {
                typeNext = blocks[einx].bdata.blockType;
              }
              let insertable = true;
              // console.log("TYPE:", typePrev, typeNext);
              /* 윗줄이 텍스트이고 아랫줄이 텍스트일때 : 생성X */
              if (insertable && (typePrev == BTPS.CONTENT && typeNext == BTPS.CONTENT)) {
                insertable = false;
              }
              /* 윗줄이 텍스트이고 아랫줄이 위젯일때 : 생성X */
              if (insertable && (typePrev == BTPS.CONTENT && (typeNext && typeNext != BTPS.CONTENT && typeNext != BTPS.TABLE))) {
                insertable = false;
              }
              /* 윗줄이 위젯이고 아랫줄이 텍스트일때 : 생성X */
              if (insertable && ((typePrev && typePrev != BTPS.CONTENT && typePrev != BTPS.TABLE) && typeNext == BTPS.CONTENT)) {
                insertable = false;
              }
              /* 윗줄이 위젯이고 아랫줄이 위젯일때 : 생성O */
              // ((typePrev && typePrev != BTPS.CONTENT && typePrev != BTPS.TABLE) && (typeNext && typeNext != BTPS.CONTENT && typeNext != BTPS.TABLE)) 
              /* 윗줄이 텍스트이고 아랫줄이 표일때 : 생성X */
              if (insertable && (typePrev == BTPS.CONTENT && typeNext == BTPS.TABLE)) {
                insertable = false;
              }
              /* 윗줄이 표이고 아랫줄이 텍스트일때 : 생성X */
              if (insertable && (typePrev == BTPS.TABLE && typeNext == BTPS.CONTENT)) {
                insertable = false;
              }
              /* 윗줄이 표이고 아랫줄이 위젯일때 : 생성O */
              // (typePrev == BTPS.TABLE && (typeNext && typeNext != BTPS.CONTENT && typeNext != BTPS.TABLE))
              /* 윗줄이 위젯이고 아랫줄이 표일때 : 생성O */
              // ((typePrev && typePrev != BTPS.CONTENT && typePrev != BTPS.TABLE) && typePrev == BTPS.TABLE)
              /* 윗줄이 비텍스트 이고 마지막 줄인경우 : 생성O */
              // ((typePrev && typePrev != BTPS.CONTENT) && einx >= blocks.length - 1)
              /* 윗줄이 텍스트 이고 마지막 줄인경우 윗줄이 비어있는 블럭이면 : 생성X */
              if (insertable && (typePrev == BTPS.CONTENT && einx >= blocks.length - 1 && !block.innerText(true))) {
                insertable = false;
              }
              /* 윗줄이 텍스트 이고 마지막 줄인경우 윗줄이 비어있지 않은 블럭이면 : 생성O */
              // (typePrev == BTPS.CONTENT && einx >= blocks.length - 1 && block.innerText())
  
              if (!insertable) {
                console.log("Clicked inter text block", einx, blocks.length, typePrev, typeNext);
              }
              else {
                self.tracelog("CREATE-TEMP:", sortNo);
                util.createTempBlock({ sortNo: sortNo, content: "" }, (block) => {
                  util.blurPrevFocusedBlock(block);
                  util.focusBlock(block, 0, true);
                  util.blockOwned = block;
                  block.bdata.isTemp = true;
                  block.$refs.buttonComment.firstChild.classList.add("hidden");
                  self.state.focusedBlockType = block.blockType();
                });
              }
            }
          }
          else {
            self.tracelog("CREATE-TEMP:0");
            util.createTempBlock({ sortNo: 0, content: "" }, (block) => {
              util.blurPrevFocusedBlock(block);
              util.focusBlock(block, 0, true);
              util.blockOwned = block;
              block.bdata.isTemp = true;
              block.$refs.buttonComment.firstChild.classList.add("hidden");
              self.state.focusedBlockType = block.blockType();
            });
          }
        }
      }
      else {
        /* 에디터블럭을 클릭한 경우 */
        let blockId = self.findBlock(elem);
        if (blockId) {
          elem = self.$dm(e.target);
          // 블럭인 경우
          // console.log("BLOCK-ID:" + blockId);
          let block = self.paperBlockMap[blockId];
          if (block && block.element) {
            block = block.element;
            self.tracelog("CLICK-BLOCK:", block.editorType(), block.focusable(), block.blockType(), block.checkLockOwn());

            if (block.blockType() == self.BTPS().LINE) {
              block.state.focused = true;
            }
            if (block.editorType()) {
              if (block.focusable()) {
                util.blockOwned = block;
                util.blurPrevFocusedBlock(block);
                if (elem.ps("editor-wrapper")) {
                  util.focusBlock(block, -1, true);
                }
                self.state.focusedBlockType = block.blockType();
              }
              else {
                self.CANCEL_EVENT({event: e});
              }
            }
            else {
              util.blockOwned = block;
              util.blurPrevFocusedBlock(block);
              if (elem.ps("editor-wrapper")) {
                util.focusBlock(block, -1, true);
              } else 
              if (block.focus) { block.focus(); }
            }
          }
        }
      }
    }, 50),
    findBlock(elem) {
      let blockId = null;
      for (let inx = 0, tmpId = null; inx < 100; inx++) {
        if (!elem || !elem.getAttribute) { break; }
        tmpId = elem.getAttribute("data-block-id");
        if (tmpId) {
          blockId = tmpId;
          break;
        }
        elem = elem.parentNode;
      }
      return blockId;
    },
    findBlockByCursor(e) {
      let blockList = this.paperBlockIdList;
      let scrollTop = window.scrollY || window.pageYOffset;
      let scrollLeft = window.scrollX || window.pageXOffset;

      let clientTop = scrollTop + e.clientY;
      let clientLeft = scrollLeft + e.clientX;

      for (let inx = 0; inx < blockList.length; inx++) {
        let blockMap = this.paperBlockMap[blockList[inx]];
        if (blockMap && blockMap.element && blockMap.element.$el) {
          let element = blockMap.element.$el;
          if (inx == 0 && element.offsetTop > clientTop) {
            return blockMap;
          }
          if (inx + 1 == blockList.length && element.offsetTop + element.offsetHeight <= clientTop) {
            return blockMap;
          }
          else if (element.offsetTop < clientTop && element.offsetTop + element.offsetHeight > clientTop) {
            return blockMap;
          }
        }
      }
      return null;
    },
    refreshBoardMemberInfo() {
      this.$emit("refreshBoardMemberInfo");
    },
    reloadContentBlocks() {
      let self = this;
      let param = {
          /* 블럭정보 받아오기 */
          uri: "/getPaperIdBlockList",
          param: { paperId: self.paperInfo.paperId },
          callback: function (res) {
            let result = {};
            let error = { code: "", message: "" };
            if (res.errorCode) { 
              console.log('getPaperBlockList error ', res.errorCode); 
            }
            if (res.data.result) { result = res.data.result; }
            if (result.data) { self.paperBlockIdSubscribe(result.data, error); }
          },
        };
      this.boardUtil.apiCall(param);
    },
    registerBlockTrigger(paperBlockId, callback) {
      let triggers = [];
      if (!(triggers = this.paperBlockTriggers[paperBlockId])) {
        triggers = [];
        this.paperBlockTriggers[paperBlockId] = triggers;
      };
      triggers[triggers.length] = callback;
      // console.log("TRIGGERS:", triggers.length);
    },
    BTPS() { return this.boardUtil.blockTypes; },
    OTPS() { return this.boardUtil.ownTypes; },
    $dm(e, a) { return this.boardUtil.$dm(e, a); },
    todoModalOpen() {
      const modalInfo = {
        name: "todoModal",
        obj: this.$modal,
        component: todoModal,
        width: "800px",
        height: "807px",
        item: {
          userInfo: this.userInfo,
          paperInfo: this.paperInfo,
          category: this.category,
          sortNo: this.boardUtil.blockOwned.bdata.sortNo,
        }
      };
      this.showModal(modalInfo);
    },
    getPaperTagList() {
      /* 태그정보 받아오기 */
      let obj = this;
      let reqData = {};
      reqData.params = {
          paperId: obj.paperInfo.paperId,
      };
      reqData.url = "/api/copaper/tag/getTagListByPaperId",
      reqData.method = "post";
      
      obj.COWORK_REST_SIMPLE_ACTION(reqData)
      .then(function(res) {
        if(res.result != null && res.result.length != 0){
          obj.selectedTags = res.result;
          obj.selectedJobGroup = res.result[0].rootHtagCategoryId;
        }
      })
      .catch(function(err) {
          console.log(err);
      });
    },
    setTags(){
      const modalInfo = {
        title: this.$i18nUtil.trans("title.SetTagsModal.001","태그설정"),
        obj: this.$modal,
        tagList : this.selectedTags,
        selectedJobGroup : this.selectedJobGroup,
        component: setTagsModal,
      };
      this.showModal(modalInfo);
    },
    updateTag(tagData) {
      let obj = this;
      let param = {
        paperId: obj.paperInfo.paperId,
        tagList: tagData.tagList,
      };
      let url = "/api/copaper/paper/updatePaperTag";

      axios.post(url, param)
      .then((res) => {
        if(res.data.errorCode) {
          console.log(res.data.errorCode);
        } else {
          obj.selectedTags = tagData.tagList;
          obj.selectedJobGroup = tagData.selectedJobGroup;

          let toastInfo = {
            obj: this.$toasted,
            message: obj.$i18nUtil.trans("TB101"),
            options: { theme: "toasted-primary", position: "bottom-left", duration: 3000, },
          };
          obj.showToast(toastInfo);  
        }
      }).catch((err) => {
        console.log("axios err => ", err);
      });
    },
     /** 테이블 버블 메뉴 SHOW / HIDE **/
    focusTable(focus, paperBlockId, commands) {
      let menubar = document.getElementById("mock_table_bubble_menubar");
      if (focus) {
        this.focusedTableBlockId = null;
        this.tableCommands = null;
        this.focusedTableBlockId = paperBlockId;
        this.tableCommands = commands;
        this.showTableBubbleMenu = true;

        /* 우측 전체/블럭 의견창 닫음 */
        let allComment = document.getElementById("paperAllComment").classList;
        if (!allComment.contains('active')) allComment.add("active");
        // let blockComment = document.getElementById("board-comment").classList;
        // if (!blockComment.contains('active')) blockComment.add("active");
        EventBus.$emit('toggleComment', true);
              } 
      else {
        this.focusedTableBlockId = null;
        this.focusTableActive = {
          function: null,
          param: null,
          click: this.focusTableActive.click += 1
        }
        this.tableCommands = null;
        this.showTableBubbleMenu = false;
      }
    },

    /** 테이블 메뉴 색상 팔레트 설정 **/
    isSetColor(color) {
      const regex = /[;]{0,1}\s*color\s*[:]\s*((rgb\s*\([0-9, ]+\))|([#][a-fA-F0-9]+)|([a-zA-Z0-9]+))\s*[;]{0,1}/ig;
      let selection = document.getSelection();
      if (selection && selection.rangeCount > 0) {
        let range = selection.getRangeAt(0);
        let elem = false;
        if (range && (elem = range.startContainer) && 
          (elem = elem.parentNode) && elem.nodeName == "SPAN") {
          let mat = regex.exec(elem.getAttribute("style"));
          if (mat && mat[1] == color) {
            return true;
          }
        }
      }
      return false;
    },
    /** 테이블 메뉴 색상 팔레트 SHOW / HIDE **/
    showColorPicker(show) {
      let self = this;
      let button = self.$refs.tableColorPickerBtn;
      let colorPicker = self.$refs.tableColorPickerBdy;
      if (show) {
        if (colorPicker.eventHandle) {
          clearTimeout(colorPicker.eventHandle);
        }
        colorPicker.classList.remove("hidden");
        colorPicker.style.left = button.offsetLeft + "px";
        setTimeout(self.cancelBlur, 500);
      }
      else {
        colorPicker.eventHandle = setTimeout(() => {
          colorPicker.classList.add("hidden");
        }, 300);
        // this.focusTableActive = {
        //   function: null,
        //   param: null,
        //   click: this.focusTableActive.click += 1
        //   }
      }
    },

    /* 테이블 셀 색상 적용 */
    setColorFromPicker(e, color, commands) {
      let self = this;
      let colorPicker = self.$refs.tableColorPickerBdy;
      colorPicker.classList.add("hidden");
      if (color == "#b8814c") { color = "#fff"; }
      commands.tableBackgroundColor({name: 'background', value: color})
      const nodeList = this.$el.querySelectorAll("div[contenteditable] tr>.selectedCell");
      for(let i=0; i<nodeList.length; i++) {
        let node = nodeList[i];
        node.classList.remove('selectedCell');
      }
      this.focusTableActive = {
          function: null,
          param: "tableCellColor",
          click: this.focusTableActive.click += 1
      }
    },
    /** 테이블: 셀 색상 외 이벤트 전달 **/
    setTableBubbleActive(fnc, param) {
      if (fnc !== null && param === null) {
        this.focusTableActive = {
          function: fnc,
          param: null,
          click: this.focusTableActive.click += 1
        }
      }
      else if (fnc === null && param !== null) {
        this.focusTableActive = {
          function: this.tableCommands,
          param: param,
          click: this.focusTableActive.click += 1
        }
      }
    },
    checkAuthBtn(e){
      let obj = this;
      let userGrade = this.boardMemberInfo.userList.find( item => item.userId === obj.userInfo.userId);
      if((obj.paperInfo.regUserId == obj.userInfo.userId) || (userGrade != null && userGrade.userGrade === "MANAGER")){
        let param = {
          url : "/api/copaper/paper/updateTitleLockYn",
          method : "post",
          params : {
            paperId : obj.paperInfo.paperId,
            lockYn : obj.titleLockYn ? 1:0
          }
        };

        obj
        .COWORK_REST_SIMPLE_ACTION(param)
        .then(res => {
          if(res.result != null){
            obj.titleLockYn = res.result.lockYn == 1 ? false : true;
            // e.target.classList.toggle('active');
          }
        }).catch(err => { console.log(err); });
      }else{
        if(obj.boardSection[0] == 'SHAR'){
          obj.showAlertDialog(obj.$i18nUtil.trans("message.BoardEditor.016","권한없습니다...."));
        }else{
          obj.showAlertDialog(obj.$i18nUtil.trans("message.BoardEditor.015","권한없습니다...."));
        }
      }
    },
    // 보드명 수정 잠금 사용여부.
    titleModifyLockYn() {
      let obj = this;
      let reqData = {
        url : "/api/org/getCodeValueList",
        method : "post",
        params : {
          cdCategory: 'tenant.env',
          cdKey: 'paperTitleModifyLockUseYn'
        }
      };

      obj
      .COWORK_REST_SIMPLE_ACTION(reqData)
      .then(res => {
        if(res.result != null && res.result.length != 0){
          obj.paperTitleModifyUseYn = res.result[0].cdValue == "true" ? true : false;

          if(obj.paperTitleModifyUseYn){
            let param = {
              url : "/api/copaper/paper/checkTitleLockYn",
              method : "post",
              params : {
                paperId : obj.paperInfo.paperId
              }
            };

            obj
            .COWORK_REST_SIMPLE_ACTION(param)
            .then(res => {
              if(res.result != null){
                obj.titleLockYn = res.result.lockYn == 1 ? false : true;
              }
            }).catch(err => { console.log(err); });
          }
        }
      }).catch(err => { console.log(err); });
    },
    showCalendar() {
      // 일정
      const modalInfo = {
        title: "캘린더",
        width: "95%",
        height: "95%",
        obj: this.$modal,
        component: MAS_Cal,
        projectId: this.projectInfo.projectId,
        paperId: this.paperInfo.paperId,
      };
      this.showModal(modalInfo);
    }
  },
};
</script>
<style scoped>
.ell-singleline {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  max-width: 200px;
}

#file-drop-zone > .cursor {
  background: #000 !important;
}

.edit_tool > li.unabled::before {
  content: "　";
  width: 100%;
  position: absolute;
  height: 100%;
  background: #000;
  opacity: 0.5;
}
.sortable-chosen {
  opacity: 0.5;
}

.btn_lock{
  width: 20px;
  height: 20px;
  text-indent: -999em;
  font-size: 0;
  color: transparent;
  vertical-align: middle;
  background: url(/static/img/sp_common.bec0aeb.png) no-repeat -120px -40px;
  position: absolute;
  left: -20px;
  top: 12px;
}
.btn_lock.active{
  width: 20px;
  height: 20px;
  text-indent: -999em;
  font-size: 0;
  color: transparent;
  vertical-align: middle;
  background: url(/static/img/sp_common.bec0aeb.png) no-repeat -120px -60px;
  position: absolute;
  left: -20px;
  top: 12px;
}
</style>


// WEBPACK FOOTER //
// src/components/cowork/general/board/editor/BoardEditor.vue